/** Google Consent Mode is driven by the shared consent provider. */
import {getDefaultDnt} from '@amblique/king-living/app/utils/tracking-consent';

const status = (granted) => (granted ? 'granted' : 'denied');

export const resolveGtmDefaultConsentGranted = (site) => !getDefaultDnt(site);

export const toGoogleConsent = ({statistics, marketing, preferences}) => ({
  analytics_storage: status(statistics),
  ad_storage: status(marketing),
  ad_user_data: status(marketing),
  ad_personalization: status(marketing),
  functionality_storage: status(preferences),
  personalization_storage: status(preferences),
  security_storage: 'granted',
});

export const buildConsentDefaultScript = (defaultConsentGranted = false, siteId = '') => `
(function () {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){window.dataLayer.push(arguments);};
  if (window.__klGtmConsentDefaultSet) return;
  window.__klGtmConsentDefaultSet = true;
  var granted = ${JSON.stringify(defaultConsentGranted)} && !/(?:^|;\\s*)dw_dnt=1(?:;|$)/.test(document.cookie);
  var consent = {statistics: granted, marketing: granted, preferences: granted};
  try {
    var previous = JSON.parse(window.localStorage.getItem(${JSON.stringify(`kl_gtm_cmp_consent_${siteId}`)}));
    if (previous && previous.analytics === false) consent.statistics = false;
    if (previous && previous.marketing === false) consent.marketing = false;
  } catch (e) {}
  if (navigator.globalPrivacyControl === true) consent.marketing = false;
  var status = function(value) {return value ? 'granted' : 'denied';};
  gtag('consent', 'default', {
    analytics_storage: status(consent.statistics),
    ad_storage: status(consent.marketing),
    ad_user_data: status(consent.marketing),
    ad_personalization: status(consent.marketing),
    functionality_storage: status(consent.preferences),
    personalization_storage: status(consent.preferences),
    security_storage: 'granted',
    wait_for_update: 500
  });
})();
`.trim();

export const updateGTMConsent = (consent) => {
  if (typeof window === 'undefined') return false;
  const payload = toGoogleConsent(consent);
  const key = JSON.stringify(payload);

  if (window.__klGtmConsentUpdate === key) return true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('consent', 'update', payload);
  window.__klGtmConsentUpdate = key;
  window.dataLayer.push({event: 'kl_consent_update', kl_consent: {...consent}});

  return true;
};
